import React from 'react';

/**
 * Paginazione elenco medici.
 * @param {{ page: number, totalPages: number, total: number, onPageChange: (p: number) => void }} props
 */
const MediciPagination = ({ page, totalPages, total, onPageChange }) => {
  if (totalPages <= 1) return null;

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <nav className="medici-pagination" aria-label="Pagine medici">
      <p className="medici-pagination-meta">
        Pagina {page} di {totalPages}
        {total != null ? ` · ${total} medic${total === 1 ? 'o' : 'i'}` : ''}
      </p>
      <div className="medici-pagination-btns">
        <button
          type="button"
          className="vc-btn vc-btn-outline vc-btn-sm"
          disabled={!canPrev}
          onClick={() => onPageChange(page - 1)}
        >
          Precedente
        </button>
        <button
          type="button"
          className="vc-btn vc-btn-outline vc-btn-sm"
          disabled={!canNext}
          onClick={() => onPageChange(page + 1)}
        >
          Mostra altri
        </button>
      </div>
    </nav>
  );
};

export default MediciPagination;
